import {Component, Input, OnInit} from '@angular/core';
import {RegisterForm} from '@app/sign-in/register/@form/register-form';
import {ConfigService} from "@app/@core/@config/config.service";

@Component({
  selector: 'app-vat-id-field[registerForm][showValidation]',
  templateUrl: './vat-id-field.component.html',
  styleUrls: ['./vat-id-field.component.scss']
})
export class VatIdFieldComponent implements OnInit {
  @Input() registerForm!: RegisterForm;
  @Input() showValidation!: boolean;
  isOptional = false;

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    this.isOptional = this.configService.getNetworkData()?.advertiser?.vatId !== 'mandatory';
  }

  isInvalid(): boolean {
    return this.showValidation && this.registerForm.controls.vatId.invalid;
  }

}
